/*
  Alpine `fabrics` component for the compare-colors tool — extracted from
  snippets/compare-colors.liquid so it ships from a cacheable, deferred asset instead of ~8.5KB
  of inline script.

  The payload stays in the page as Liquid data and is read from #compare-colors-data. The
  expression is `fabric` (not `fabrics`) exactly as before — do not "fix" it here without
  checking the page, it changes what the component receives.

  This file runs before alpine.min.js in document order, so the alpine:init listener is still
  registered in time.
*/
function compareColorsData() {
  var node = document.getElementById('compare-colors-data');
  if (!node) return null;
  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    return null;
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('fabrics', () => ({
    activeFabric: 'Microsuede',
    handleFabricClick(fabric) {
      this.activeFabric = fabric
    },
    fabrics: compareColorsData(),
    init() {
      this.activeFabric = this.fabrics[0].name
    },
    handleColorClick(color, url, variant, e) {
      var selectedDiv = document.getElementById("selectedColors");
      var selectedDivImages = document.getElementById("selectedColors");
      
      // stop if color already added
      var checkImageContainer = document.getElementById('ImageContainer-' + color);
      if (checkImageContainer) {
        return;
      }
      
      // count number of images, limit 4
      if (selectedDivImages.childElementCount == 4) {
        alert('Maximum 4 colors can be compared. Click X to remove a selection before adding another.');
      }

      if (selectedDivImages.childElementCount <= 3) {
        var colorButton = document.getElementById('ColorButton-' + color);
        colorButton.classList.add('on');
        // create container div
        var selectedImageContainer = document.createElement('div');
        selectedImageContainer.classList.add('selectedImageContainer');
        // add color class to image container
        selectedImageContainer.classList.add(color);
        // add color class to image container id
        selectedImageContainer.setAttribute('id', 'ImageContainer-' + color);
        // create bottom div for text/action
        var selectedImageContainerBottom = document.createElement('div');
        selectedImageContainerBottom.classList.add('selectedImageContainerBottom');
        selectedImageContainerBottom.classList.add('text-lg');
        selectedImageContainerBottom.innerHTML = color;
        // create top right div for remove
        var selectedImageContainerRemove = document.createElement('button');
        selectedImageContainerRemove.setAttribute('onclick','handleRemoveClick("' + color + '");');
        selectedImageContainerRemove.classList.add('selectedImageContainerRemove');
        selectedImageContainerRemove.classList.add('text-lg');
        selectedImageContainerRemove.innerHTML = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve"><line class="st0" x1="16.34" y1="13.42" x2="16.34" y2="28.85"/><line class="st0" x1="25.47" y1="13.42" x2="25.47" y2="28.85"/><g><path d="M4.96,1.14C5.62,0.71,6.19,0.5,6.66,0.5c0.61,0,1.36,0.38,2.23,1.13c0.87,0.76,2.21,2.12,4,4.11 c4.96,5.57,7.62,8.36,8,8.36c0.05,0,2.13-2.22,6.23-6.66c2.45-2.78,4.19-4.63,5.2-5.52c1.01-0.9,1.85-1.35,2.51-1.35 c0.42,0,0.92,0.14,1.49,0.42c0.8,0.38,1.59,1.07,2.37,2.09c0.78,1.02,1.17,1.88,1.17,2.58c0,0.76-0.37,1.63-1.1,2.62 c-0.73,0.99-2.63,3.16-5.7,6.51c-3.64,4.06-5.45,6.23-5.45,6.52c0,0.28,1.89,2.41,5.67,6.37c3.16,3.31,5.11,5.44,5.84,6.41 c0.73,0.97,1.1,1.88,1.1,2.73c0,0.76-0.54,1.68-1.63,2.76c-1.28,1.28-2.38,1.91-3.33,1.91c-0.38,0-0.85-0.12-1.42-0.36 c-0.76-0.33-3.09-2.5-7.01-6.51c-3.87-3.97-5.9-5.95-6.09-5.95c-0.19,0-1.11,0.87-2.76,2.62c-3.59,3.92-6.19,6.6-7.79,8.04 C8.6,40.78,7.39,41.5,6.59,41.5c-0.19,0-0.33-0.02-0.43-0.07c-0.33-0.05-1.09-0.71-2.27-1.98c-1.27-1.42-1.91-2.62-1.91-3.61 c0-0.57,0.21-1.13,0.64-1.7c1.56-1.79,3.59-4.01,6.09-6.66c3.54-3.78,5.31-5.83,5.31-6.16c0-0.28-0.71-1.18-2.12-2.69 c-4.44-4.72-7.23-7.79-8.39-9.21C2.35,8.01,1.78,6.97,1.78,6.31c0-0.8,0.34-1.75,1.03-2.83C3.49,2.39,4.21,1.61,4.96,1.14z"/></g></svg>';
        // create bottom right div for shop if not on retired
        if (this.activeFabric != 'Retired') {
          var selectedImageContainerShop = document.createElement('div');
          selectedImageContainerShop.classList.add('selectedImageContainerShop');
          selectedImageContainerShop.classList.add('text-lg');
          selectedImageContainerShop.innerHTML = '<a class="selectedImageContainerShopButton quick-action-button quick-action-button--visibility-always quick-add tap-target" style="border: 0; border-radius: 5px; width: 24px; height: 24px; padding: 5px;" href="#" data-variant-id="' + variant + '" aria-label="Add to cart"><span class="icon icon--small"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42; width: 14px; height: 14px;" xml:space="preserve"><line class="st0" x1="16.34" y1="13.42" x2="16.34" y2="28.85"/><line class="st0" x1="18.66" y1="8.95" x2="18.66" y2="27.11"/><g><path d="M19.05,1.51c0.66-0.28,1.38-0.42,2.16-0.42c1.16,0,2.13,0.22,2.91,0.66c0.44,0.28,0.94,0.86,1.5,1.75 c0.5,0.83,0.75,3.07,0.75,6.73v5.48h5.9c3.71,0,5.9,0.14,6.57,0.42c1.27,0.66,1.91,2.3,1.91,4.9c0,1.33-0.22,2.36-0.66,3.08 c-0.56,0.89-1.36,1.47-2.41,1.75c-1.05,0.28-3.1,0.42-6.15,0.42l-5.48-0.08v6.07c0,3.38-0.14,5.5-0.41,6.36 c-0.28,0.86-1.05,1.48-2.33,1.87c-1,0.28-1.8,0.41-2.41,0.41c-0.83,0-1.74-0.22-2.74-0.66c-1.05-0.5-1.73-1.3-2.04-2.41 c-0.31-1.11-0.46-3.21-0.46-6.32v-5.32l-5.65-0.25c-3.05-0.11-5.1-0.33-6.15-0.66c-1.05-0.33-1.77-0.94-2.16-1.83 c-0.28-0.72-0.42-1.52-0.42-2.41c0-1.33,0.25-2.41,0.75-3.24c0.55-0.89,1.25-1.5,2.08-1.83c0.83-0.33,2.1-0.5,3.82-0.5 c1.22,0,2.21,0.03,2.99,0.08l5.07,0.25l0.08-5.98c0.05-3.21,0.23-5.25,0.54-6.11C16.9,2.86,17.72,2.12,19.05,1.51z"/></g></svg></span></a>';
        }
        // add selected image to div
        var selectedImage = document.createElement('img');
        selectedImage.setAttribute('src', url);
        // add image at end of div
        selectedImageContainer.append(selectedImageContainerBottom);
        selectedImageContainer.append(selectedImageContainerRemove);
        if (this.activeFabric != 'Retired')
          selectedImageContainer.append(selectedImageContainerShop);
        selectedImageContainer.append(selectedImage);
        selectedDiv.append(selectedImageContainer);
        // change the URL fragment to include this color
        var currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('select') == null)
          currentUrl.searchParams.set('select', color.toLowerCase());
        else {
          // only add color to URL if it doesn't already exist
          if (! currentUrl.searchParams.get('select').includes(color.toLowerCase()))
            currentUrl.searchParams.set('select', currentUrl.searchParams.get('select') + '-' + color.toLowerCase());
        }
        window.history.replaceState({}, '', currentUrl.toString());
      }
    }
  }))
})

// check select URL parameters and click the associated buttons
window.onload = function() {
  var currentUrlSet = new URL(window.location.href);
  if (currentUrlSet.searchParams.get('select') != null) {
    var currentUrlSetArray = currentUrlSet.searchParams.get('select').split('-');
    currentUrlSetArray.forEach(selectColor => {
      var uppercaseSelectedColor = selectColor.charAt(0).toUpperCase() + selectColor.slice(1);
      document.getElementById("ColorButton-" + uppercaseSelectedColor).click();
    });
  }
}

function handleRemoveClick(color) {
  // remove the image if already exists
  var removeImageContainer = document.getElementsByClassName("selectedImageContainer " + color)[0];
  removeImageContainer.parentNode.removeChild(removeImageContainer);
  // unhighlight color button
  var colorButton = document.getElementById('ColorButton-' + color);
  colorButton.classList.remove('on');
  // remove the URL fragment for this color
  var currentUrlRemove = new URL(window.location.href);
  if (currentUrlRemove.searchParams.get('select') != null) {
    // if color- remove
    if (currentUrlRemove.searchParams.get('select').includes(color.toLowerCase() + '-'))
      currentUrlRemove.searchParams.set('select', currentUrlRemove.searchParams.get('select').replace(color.toLowerCase() + '-', ''));
    // if -color remove
    else if (currentUrlRemove.searchParams.get('select').includes('-' + color.toLowerCase()))
      currentUrlRemove.searchParams.set('select', currentUrlRemove.searchParams.get('select').replace('-' + color.toLowerCase(), ''));
    // if =color remove
    else
      currentUrlRemove.searchParams.delete('select');
  }
  window.history.replaceState({}, '', currentUrlRemove.toString());
}
